import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { SimulationProvider } from "@/context/SimulationContext";
import HomePage from "@/pages/HomePage";
import SimulatorPage from "@/pages/SimulatorPage";
import SavedSimulationsPage from "@/pages/SavedSimulationsPage";
import AdminPresetsPage from "@/pages/AdminPresetsPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <SimulationProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/simulator" element={<SimulatorPage />} />
              <Route path="/saved" element={<SavedSimulationsPage />} />
              <Route path="/admin/presets" element={<AdminPresetsPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            richColors
            position="top-right"
            toastOptions={{
              className: "font-mono",
            }}
          />
        </SimulationProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
